// store/authTokenMiddleware.js - every logout path in the app ends in auth/logout or
// auth/resetAuth; this ends the login session on the server too (refresh token revoked).
import { serverLogout } from '../utilities/authToken';

const LOGOUT_ACTIONS = ['auth/logout', 'auth/resetAuth'];

const authTokenMiddleware = () => (next) => (action) => {
    const result = next(action);
    if (LOGOUT_ACTIONS.includes(action?.type)) {
        serverLogout();
    }
    return result;
};

export default authTokenMiddleware;
